module.exports = __webpack_public_path__ + "img/ic-setting-active.80113c38.svg";